import Icon from 'veui/components/Icon'

Icon.register({
  'view-tile': {
    paths: [
      {
        d: 'M320 351H96a32 32 0 01-32-32V96a32 32 0 0132-32h224a32 32 0 0132 32v223a32 32 0 01-32 32zm-192-64h160V128H128zm192 64H96a32 32 0 01-32-32V96a32 32 0 0132-32h224a32 32 0 0132 32v223a32 32 0 01-32 32zm-192-64h160V128H128zm544 65H448a32 32 0 01-32-32V96a32 32 0 0132-32h224a32 32 0 0132 32v224a32 32 0 01-32 32zm-192-64h160V128H480zM320 703H96a32 32 0 01-32-32V448a32 32 0 0132-32h224a32 32 0 0132 32v223a32 32 0 01-32 32zm-192-64h160V480H128zm192 64H96a32 32 0 01-32-32V448a32 32 0 0132-32h224a32 32 0 0132 32v223a32 32 0 01-32 32zm-192-64h160V480H128zm544 65H448a32 32 0 01-32-32V448a32 32 0 0132-32h224a32 32 0 0132 32v224a32 32 0 01-32 32zm-192-64h160V480H480z'
      }
    ],
    width: '768',
    height: '768'
  }
})
